import { GraphNode } from '../graph-node.js';
import { traceGraph, traceGraphWarning } from '../debug.js';
/**
 * Fires every `customEvent` node with the same `eventId`, then continues Then.
 * The event strand is started immediately; Then does not wait for latent nodes.
 */
export class CallCustomEventNode extends GraphNode {
    graphNodes = [];
    bindGraphNodes(nodes) {
        this.graphNodes = nodes;
    }
    run() {
        super.run();
        const eventId = typeof this.data.eventId === 'string' ? this.data.eventId : '';
        if (!eventId) {
            traceGraphWarning(`callCustomEvent (${this.id}) has no eventId - nothing to fire`);
            this.triggerOutPort('exec');
            return;
        }
        let firedCount = 0;
        for (const node of this.graphNodes) {
            if (node === this)
                continue;
            if (node.type !== 'customEvent')
                continue;
            if (String(node.data.eventId ?? '') !== eventId)
                continue;
            firedCount += 1;
            node.triggerOutPort('exec');
        }
        traceGraph(`callCustomEvent (${this.id}) fired ${firedCount} customEvent node(s)`, {
            eventId
        });
        this.triggerOutPort('exec');
    }
}
